import React from 'react';

import { CircularProgress } from '@mui/material';

import { ICON_SIZE_PX_NE } from '../../../../constants/buttons';
import { CONTROLLER_ON, WHITE } from '../../../../constants/colors';
import { IBdsButton } from '../../../../interfaces/buttons';

import './BdsButton.scss';

const customStyles = {
  customLoadingWhite: {
    color: WHITE
  },
  customLoadingBlack: {
    color: CONTROLLER_ON
  }
};

const BdsButton = ({
  action,
  disabled,
  loading,
  children,
  variant,
  size,
  iconLeft,
  iconRight,
  loadingType = 'default',
  loadingText = ''
}: React.PropsWithChildren<IBdsButton>) => {
  const classNames = ['bds-button', variant, size, loading ? 'loading' : ''].join(' ');

  const spinnerStyle = {
    primary: customStyles.customLoadingWhite,
    primaryInverse: customStyles.customLoadingBlack,
    secondary: customStyles.customLoadingBlack,
    inverse: customStyles.customLoadingBlack,
    secondaryInverse: customStyles.customLoadingWhite,
    variable: customStyles.customLoadingBlack,
    tertiary: customStyles.customLoadingBlack,
    quaternary: customStyles.customLoadingBlack
  };

  const renderContent = () => {
    return (
      <>
        {iconLeft && <iconLeft.component className="bds-button-icon" />}
        <div className="bds-button">{children}</div>
        {iconRight && <iconRight.component className="bds-button-icon" />}
      </>
    );
  };

  const renderLoading = () => {
    if (loadingType === 'left') {
      return (
        <>
          <CircularProgress sx={{ ...spinnerStyle[variant] }} size={ICON_SIZE_PX_NE[size]} />
          <div className="bds-button">{loadingText}</div>
        </>
      );
    }
    if (loadingType === 'right') {
      return (
        <>
          <div className="bds-button">{loadingText}</div>
          <CircularProgress sx={{ ...spinnerStyle[variant] }} size={ICON_SIZE_PX_NE[size]} />
        </>
      );
    }
    return <CircularProgress sx={{ ...spinnerStyle[variant] }} size={ICON_SIZE_PX_NE[size]} />;
  };

  return (
    <button disabled={loading || disabled} className={classNames} onClick={action}>
      {loading && renderLoading()}
      {!loading && renderContent()}
    </button>
  );
};

export default BdsButton;
